import React, { useState, useEffect } from 'react';
import Modal from '../Modal/Modal';
import ConfirmAndCancel from '../Buttons/ConfirmAndCancel';
import Moment from 'react-moment';
import FormDropdown from "../FormField/FormDropdown";
import { getClass, getValidStartDate } from "../../Helper";
import { notify } from "react-notify-toast";
import { connect } from 'react-redux'
import { API } from '../../API';

function ChangeBookingLevelPopupCollege(
  { show, onClose, onConfirm, booking, campus, classData, updatedLevel, updatedLevelID, setUpdatedLevel, simpleQualifications }
) {
  const {
    level
  } = booking;

  if (!campus || !campus._id && booking?.campus) {
    campus = booking.campus
  }

  const [simpleQualificationList, setSimpleQualifications] = useState(simpleQualifications)

  const getClassName = (key) => {
    const cls = getClass().find((cl) => cl.key === key) || {};
    return cls.whole_name;
  };

  const getEndBookingDate = (booking) => {
    return booking.dates[booking.dates?.length - 1]?.date
  }

  const getStartBookingDate = (booking) => {
    if (booking.multiple_date) {
      return booking.dates[0]?.date
    } else {
      return booking.booking_date
    }
  }

  const handleChangeLevel = () => {
    if (!updatedLevel || !updatedLevelID) {
      notify.show("Please select a level")
    } else {
      onConfirm();
      onClose();
    }
  }

  const getClassOption = (levelID) => {
    const levelItem = simpleQualificationList.find(ele => ele._id === levelID)
    return levelItem ? (levelItem?.code ? `${levelItem.title} (${levelItem.code})` : levelItem.title)
      : levelID
  }

  useEffect(() => {
    // check simpleQualification list
    if(!simpleQualificationList?.length) {
      API.getSimpleQualification().then(res => {
        setSimpleQualifications(res?.data?.data)
      })
    }
  }, [])

  return (
    <Modal
      show={show}
      onClose={onClose}
      header='Edit Booking Level'
      className='delete-modal'
    >
      <p className='center-text my-3'>
        <span>
          <Moment format='DD MMM YYYY'>{getStartBookingDate(booking)}</Moment>
          {getEndBookingDate(booking) && getEndBookingDate(booking) !== getStartBookingDate(booking) && (
            <>
              {' - '}
              <Moment format='DD MMM YYYY'>{getEndBookingDate(booking)}</Moment>
            </>
          )}
        </span>
        <br/>
        <span>
          {campus
            ? `${level} @ ${campus.address_line1 + (campus.address_line2 ? ', ' + campus.address_line2 : '')}`
            : ''}
        </span>
      </p>
      <FormDropdown
        id="level"
        label="Select Updated Level"
        onChange={(e) => setUpdatedLevel(getClassOption(e.target.value), e.target.value)}
        className="w-75 m-auto"
        defaultValue={booking.class_level_id}
        // disabled={this.state.class_error_message}
        required
      >
        <option value="" key="default">
          Select class level
        </option>
        {classData.selected_levels?.map((lvlID, index) => {
          return (
            <option value={lvlID} key={index}>
              {getClassOption(lvlID)}
            </option>
          );
        })}
      </FormDropdown>
      {(
        <ConfirmAndCancel
          onCancel={onClose}
          cancelText='Go Back'
          onConfirm={handleChangeLevel}
          confirmText='Change Booking Level'
        />
      )}
    </Modal>
  );
}
function mapStateToProps(state) {
  return {
    simpleQualifications: state.user?.simpleQualifications || []
  }
}

export default connect(mapStateToProps)(ChangeBookingLevelPopupCollege)